import { salesReportQuery, salesReportResponse } from 'interfaces/Dashboard';
import api from 'services';

// eslint-disable-next-line import/prefer-default-export
export const getSalesReport = async (params: salesReportQuery): Promise<salesReportResponse> => {
  const response = await api.get<salesReportResponse>('reports/dashboard/sales', { params });
  return response.data;
};
